angular
    .module('octopusApp.infrastructure')
    .directive("octoPermission", function($rootScope, octopusPermissionSet, $timeout, $q) {

      var update = function (element, permission, project, environment, projectGroup, wildcard) {
        element.addClass('octo-permission-unknown');
        element.removeClass('octo-permission-denied');

        var pid = project || (wildcard ? '*' : null);
        var eid = environment || (wildcard ? '*' : null);
        var gid = projectGroup || (wildcard ? '*' : null);

        var permissions = permission.split(',');

        var checks = [];
        _.each(permissions, function (p) {
          checks.push(octopusPermissionSet.isAuthorized({
            permission: p,
            projectId: pid,
            environmentId: eid,
            projectGroupId: gid
          }));
        });

        $q.all(checks).then(function (yn) {
          var allowed = _.any(yn, function (y) {
            return y === true;
          });

          element.removeClass('octo-permission-unknown');
          if (!allowed) {
            element.addClass('octo-permission-denied');
            element.attr('octo-denied-project', pid);
            element.attr('octo-denied-environment', eid);
          }
        });
      };

      return {
        restrict: 'A',
        replace: false,
        link: function (scope, element, attr) {
          var permission = attr.octoPermission;
          var project = attr.octoProject;
          var environment = attr.octoEnvironment;
          var group = attr.octoProjectGroup;

          var wildcard = 'wildcard' in attr;

          var p = project ? scope.$eval(project) : null;
          var e = environment ? scope.$eval(environment) : null;
          var g = group ? scope.$eval(group) : null;

          var doUpdate = function () {
            update(element, permission, p, e, g, wildcard);
          };
          doUpdate();

          var unwatchStatus = $rootScope.$watch('isAuthenticated', function (newVal) {
            doUpdate();
          });

          if (project && environment) {

            scope.$watchCollection('[' + project + ',' + environment + ']', function (newPE) {
              p = newPE[0];
              e = newPE[1];
              doUpdate();
            });

          } else {

            if (project) {
              scope.$watch(project, function (newP) {
                p = newP;
                doUpdate();
              });
            }

            if (environment) {
              scope.$watch(environment, function (newE) {
                e = newE;
                doUpdate();
              });
            }

            if (group) {
              scope.$watch(group, function (newG) {
                g = newG;
                doUpdate();
              });
            }
          }

          scope.$on('$destroy', unwatchStatus);
        }
      };
    });


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_permission.js
// module id = 5804767763271065
// module chunks = 1